export default "__VITE_ASSET__BAoKVT8Y__"